import Bloqueo from '@pages/bloqueo';

export default [
    {
        path: '/bloqueo',
        name: 'bloqueo',
        component: Bloqueo,
    },
];
